import {
  Delete,
  AddCircleOutline,
  Edit,
  HelpOutline,
  Email,
  Smartphone,
} from "@material-ui/icons";
import React from "react";
import { Button, Col, Row, Modal } from "react-bootstrap";
import InputMask from "react-input-mask";
import Table from "react-bootstrap/Table";
import PhoneNumber from "./../../Common/phoneNumber";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import APIUtil from "./../../../config/APIUtil";
import UrlConstants from "./../../../config/UrlConstants";
import { cryptoTokenDecode, formatPhoneNumber } from "./../../Common/Common";
import * as message from "./../../../config/CommonMessages";

class Buyers extends React.Component {
  constructor(props) {
    super(props);

    var userType = cryptoTokenDecode().usertype;
    this.state = {
      buyers: this.props.getTransactionData().buyers || [],
      defaultBuyer: this.props.getTransactionData().buyer,
      buyerDataInfo: {
        email: "",
        firstname: "",
        lastname: "",
        mobileNumber: "",
      },
      isEdit: false,
      updateKey: undefined,
      userType: userType.toUpperCase(),
      deletePrompt: false,
      deleteIndex: "",
      isEmailValid: false,
      isDisabled: true,
      isShowEmailValidation: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    return {
      buyers: props.getTransactionData().buyers,
    };
  }

  getData() {
    return this.props.getTransactionData().buyers;
  }

  /**
   *
   * @desc show delete prompt
   * @param {*} index
   */
  deletePrompt(index) {
    this.setState({
      deletePrompt: !this.state.deletePrompt,
      deleteIndex: index,
    });
  }

  /**
   * @desc delete buyer data from state and update transaction data
   */
  deleteRecord(ind) {
    let buyers = this.state.buyers;

    if (buyers[ind] !== undefined) {
      delete buyers[ind];
    }
    var allBuyers = buyers.filter(function(el) {
      return el != null;
    });
    this.setState({ buyers: allBuyers, isEdit: false });
    this.props.updateTransactionData("updatedBuyer", []);
    this.props.updateTransactionData("buyers", allBuyers);
    this.deletePrompt();
  }

  /**
   * @desc add new buyer to buyer state and update transaction data
   */
  addRecord(values) {
    let buyers = this.state.buyers;
    let isExist = false;
    if (this.state.defaultBuyer.email === values.email) {
      isExist = true;
    }
    for (let i = 0; i < buyers.length; i++) {
      if (!!buyers[i] && !!buyers[i].email) {
        if (buyers[i].email === values.email) {
          isExist = true;
        }
      }
    }

    if (isExist) {
      this.setState({ isShowEmailValidation: true });
    } else {
      this.setState({ isShowEmailValidation: false });
      values.mobileNumber = values.mobileNumber.toString().replace(/\-/g, "");
      buyers.push(values);
      this.setState({ buyers, isEdit: false });
      this.props.updateTransactionData("updatedBuyer", []);

      this.props.updateTransactionData("buyers", buyers);
      this.buyerInfoModal();
    }
  }

  /**
   * @desc update buyer to buyer state and update transaction data
   */
  updateRecord(values) {
    let buyers = this.state.buyers;

    values.mobileNumber = values.mobileNumber.toString().replace(/\-/g, "");

    if (this.state.updateKey !== undefined) {
      buyers[this.state.updateKey] = values;
    }
    this.setState({ buyers, isEdit: false, updateKey: undefined });
    this.props.updateTransactionData("buyers", buyers);
    this.buyerInfoModal();
  }
  /**
   * @desc load existing buyer data to modal
   */
  editRecord(e, buyer, key) {
    this.setState({ buyerDataInfo: buyer, isEdit: true, updateKey: key });
    this.buyerInfoModal();
  }

  /**
   * @desc clear form states
   */
  clearForm(isEmailNeeded, email) {
    this.setState({
      buyerDataInfo: {
        email: isEmailNeeded ? email : "",
        firstname: "",
        lastname: "",
        mobileNumber: "",
      },
      isEmailValid: false,
      isExist: false,
    });
  }

  // Buyer Info modal
  buyerInfoModal() {
    this.setState({ buyerInfo: !this.state.buyerInfo });
  }

  /**
   *
   * @desc check entered email is exist or not
   */
  checkEmailExist(email, errors, setFieldError) {
    if (email !== "") {
      let buyers = this.state.buyers;
      let isExist = false;
      let buyerData = {};
      for (let i = 0; i < buyers.length; i++) {
        if (buyers[i] !== undefined) {
          if (buyers[i].email === email) {
            isExist = true;
            buyerData = buyers[i];
            break;
          }
        }
      }

      if (isExist) {
        var contact = {
          firstname: !!buyerData.firstname ? buyerData.firstname : "",
          lastname: !!buyerData.lastname ? buyerData.lastname : "",
          mobileNumber: !!buyerData.mobileNumber ? buyerData.mobileNumber : "",
          email: email,
        };
        this.setState({
          isShowEmailValidation: true,
          isDisabled: true,
          isExist: true,
          buyerDataInfo: contact,
        });
      } else {
        this.setState({ isShowEmailValidation: false });
        this.clearForm(true, email);

        if (errors["email"] === undefined) {
          APIUtil.getMethod(
            UrlConstants.emailCheckUrl + "?email=" + email,
            false
          ).then((response) => {
            if (response.data && response.data._id !== undefined) {
              if (Object.keys(response.data).length > 0) {
                var contact = {
                  firstname: response.data.firstname,
                  lastname: response.data.lastname,
                  mobileNumber: response.data.mobileNumber,
                  email: email,
                };
                this.setState({
                  isEmailValid: true,
                  buyerDataInfo: contact,
                  isDisabled: true,
                  isExist: false,
                });
              } else {
                this.clearForm(true, email);
                this.setState({ isDisabled: false });
              }
            } else {
              this.clearForm(true, email);
              this.setState({ isDisabled: false });
            }
          });
        }
      }
    } else {
      this.clearForm(true, email);
      this.setState({ isShowEmailValidation: false });
    }
  }

  render() {
    if (this.props.isCreated) {
      return this.createRender();
    } else {
      return this.updateRender();
    }
  }

  createRender() {
    return (
      <div className="col-12">
        <Row>
          {/* <Col sm="4">
            <h4 className="title-small font-600 mt-2">Client Information</h4>
          </Col> */}

          {/* <Col sm="8" className="text-right">
            {this.state.userType === message.ACCTOWNER &&
              this.props.transStatus !== "COMPLETED" && (
                <Button
                  variant="transparent"
                  className="p-0"
                  onClick={() => {
                    let isDefaultBuyerAdded = this.props.checkDefaultBuyerData();
                    if (isDefaultBuyerAdded) {
                      this.props.hideDefaultBuyerErr();
                      this.clearForm(false);
                      this.buyerInfoModal();
                      this.setState({
                        isDisabled: true,
                        isShowEmailValidation: false
                      });
                    } else {
                      this.props.showDefaultBuyerErr();
                    }
                  }}
                >
                  <AddCircleOutline className="add" />
                  <span
                    style={{
                      verticalAlign: "middle",
                      marginLeft: "2px",
                      fontWeight: "450"
                    }}
                  >
                    Add Buyer
                  </span>
                </Button>
              )}
          </Col> */}
          <Col xs={12}>
            <div className="brokerage-fees mb-3">
              {this.state.buyers && this.state.buyers.length > 0 && (
                <div className="brokerage-fees-body">
                  <Table className="add-buyer-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th className="buyer-action">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.buyers &&
                        this.state.buyers
                          .filter((buyer) => buyer !== null)
                          .map((buyer, ind) => {
                            return (
                              <tr>
                                <td className="title">
                                  {" "}
                                  {buyer.firstname + " " + buyer.lastname}
                                </td>
                                <td className="value">
                                  <a href={"mailto:" + buyer.email}>
                                    {buyer.email}
                                  </a>
                                </td>
                                <td className="value">
                                  <a href={"tele:" + buyer.mobileNumber}>
                                    <PhoneNumber
                                      phoneNumber={buyer.mobileNumber}
                                    />
                                  </a>
                                </td>
                                <td>
                                  {this.state.userType === message.ACCTOWNER &&
                                    this.props.transStatus !== "COMPLETED" && (
                                      <div className="status">
                                        <Button
                                          variant="transparent"
                                          onClick={(e) =>
                                            this.editRecord(e, buyer, ind)
                                          }
                                        >
                                          <Edit className="edit" />
                                        </Button>
                                        <Button
                                          className="trash-icn"
                                          variant="transparent"
                                          onClick={(e) =>
                                            this.deletePrompt(ind)
                                          }
                                        >
                                          <Delete />
                                        </Button>
                                      </div>
                                    )}
                                </td>
                              </tr>
                            );
                          })}
                    </tbody>
                  </Table>
                </div>
              )}
            </div>
          </Col>
        </Row>

        <Modal
          show={this.state.buyerInfo}
          onHide={() => this.buyerInfoModal()}
          initialValues={this.state.buyerDataInfo}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med"
        >
          <Formik
            validateOnBlur={true}
            initialValues={this.state.buyerDataInfo}
            enableReinitialize={true}
            validationSchema={
              this.state.isEmailValid || this.state.isDisabled
                ? Yup.object().shape({
                    email: Yup.string()
                      .email(message.ENTER_VALID_EMAIL)
                      .required(message.ENTER_EMAIL),
                  })
                : Yup.object().shape({
                    firstname: Yup.string().required(
                      message.ENTER_CLIENT_FIRST_NAME
                    ),
                    lastname: Yup.string().required(
                      message.ENTER_CLIENT_LAST_NAME
                    ),
                    email: Yup.string()
                      .nullable()
                      .email(message.ENTER_VALID_EMAIL)
                      .required(message.ENTER_EMAIL),
                    mobileNumber: Yup.string()
                      .nullable()
                      .required(message.ENTER_MOBILE_NUMBER)
                      .test(
                        "mobileNumber",
                        message.ENTER_VALID_MOBILE,
                        (value) => {
                          if ((value || "").length === 10) {
                            return true;
                          }
                          return false;
                        }
                      ),
                  })
            }
            onSubmit={(values) => {
              if (this.state.isEdit) {
                this.updateRecord(values);
              } else {
                this.addRecord(values);
              }
            }}
          >
            {({
              errors,
              values,
              handleBlur,
              setFieldValue,
              touched,
              setFieldError,
            }) => (
              <Form className="form-sm form-admin">
                <Modal.Header closeButton>
                  <Modal.Title id="example-custom-modal-styling-title">
                    Buyer Information
                  </Modal.Title>
                </Modal.Header>

                <Modal.Body className="pb-0">
                  <Row>
                    <Col xs={12} sm={6}>
                      <div className="form-group">
                        <label className="form-label" htmlFor="email">
                          Email Address<span className="text-danger">*</span>
                        </label>
                        <Field
                          name="email"
                          type="text"
                          value={values.email}
                          onChange={(e) => {
                            setFieldValue("email", e.target.value);
                            this.checkEmailExist(
                              e.target.value,
                              errors,
                              setFieldError
                            );
                          }}
                          onBlur={handleBlur}
                          className={
                            "form-control" +
                            (errors.email && touched.email ? " is-invalid" : "")
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {errors.email}
                        </div>
                        {this.state.isShowEmailValidation && (
                          <div
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            Buyer already exists.
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col xs={12} sm={6}>
                      <div className="form-group">
                        <label className="form-label" htmlFor="mobileNumber">
                          Phone (Mobile)<span className="text-danger"> *</span>
                        </label>

                        {this.state.isEmailValid || this.state.isDisabled ? (
                          <Field
                            name="mobileNumber"
                            type="text"
                            disabled
                            value={formatPhoneNumber(values.mobileNumber)}
                            onChange={(e) => {
                              var mob = e.target.value
                                .toString()
                                .toString()
                                .replace(/-/g, "");
                              setFieldValue("mobileNumber", mob);
                            }}
                            className={
                              "form-control" +
                              (errors.mobileNumber && touched.mobileNumber
                                ? " is-invalid"
                                : "")
                            }
                          />
                        ) : (
                          <InputMask
                            mask="999-999-9999"
                            maskChar=""
                            className={
                              "form-control" +
                              (errors.mobileNumber && touched.mobileNumber
                                ? " is-invalid"
                                : "")
                            }
                            formControlProps={{
                              fullWidth: true,
                            }}
                            value={values.mobileNumber}
                            name="mobileNumber"
                            onChange={(e) => {
                              var mob = e.target.value
                                .toString()
                                .toString()
                                .replace(/-/g, "");
                              setFieldValue("mobileNumber", mob);
                            }}
                            onBlur={handleBlur}
                          >
                            {(inputProps) => <Field {...inputProps} />}
                          </InputMask>
                        )}

                        <ErrorMessage
                          name="mobileNumber"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} sm={6}>
                      <div className="form-group">
                        <label className="form-label" htmlFor="firstname">
                          First Name
                          <span className="text-danger"> *</span>
                        </label>
                        <Field
                          name="firstname"
                          type="text"
                          disabled={
                            this.state.isEmailValid || this.state.isDisabled
                          }
                          value={values.firstname}
                          className={
                            "form-control field_ucfirst" +
                            (errors.firstname && touched.firstname
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="firstname"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col xs={12} sm={6}>
                      <div className="form-group">
                        <label className="form-label" htmlFor="lastname">
                          Last Name<span className="text-danger"> *</span>
                        </label>
                        <Field
                          name="lastname"
                          type="text"
                          disabled={
                            this.state.isEmailValid || this.state.isDisabled
                          }
                          value={values.lastname}
                          className={
                            "form-control field_ucfirst" +
                            (errors.lastname && touched.lastname
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="lastname"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="primary"
                    type="submit"
                    size="sm"
                    className="btn-blue w-140"
                  >
                    Save
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>

        {/* Delete Modal */}
        <Modal
          show={this.state.deletePrompt}
          onHide={() => this.deletePrompt()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}
        >
          <Modal.Body className="pb-0 text-center">
            <HelpOutline />
            <p>Are you sure you want to delete this buyer?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => {
                this.deletePrompt();
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.deleteRecord(this.state.deleteIndex);
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

  // THIS IS WHAT IS DISPLAYED IN THE UI
  updateRender() {
    return (
      <div>
        <Row>
          {this.state.userType === message.VENDOR ||
          this.state.userType === message.ACCTOWNER ? (
            <>
              {this.state.buyers &&
                this.state.buyers
                  .filter((buyer) => buyer !== null)
                  .map((buyer, ind) => {
                    return (
                      <Col xs="12" sm="10">
                        <h4 className="font-14 color-black">
                          Client Information
                        </h4>
                        <h1 className="font-20 mb-1 font-600 text-capitalize">
                          {buyer.firstname + " " + buyer.lastname}
                        </h1>
                        <table
                          border="0"
                          className="mt-2 trans-table trans-table-normal"
                        >
                          <tbody>
                            <tr>
                              <td
                                className="text-key"
                                style={{ width: "35px" }}
                              >
                                {buyer.email && (
                                  <a
                                    className="mr-2"
                                    href={"mailto:" + buyer.email}
                                  >
                                    <Email />
                                  </a>
                                )}
                              </td>
                              <td className="text-val font-14">
                                <div className="email-case">{buyer.email}</div>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-key">
                                <a
                                  style={{ color: "black" }}
                                  href={"tele: " + buyer.mobileNumber}
                                >
                                  {buyer.mobileNumber && <Smartphone />}
                                </a>
                              </td>
                              <td className="text-val font-14">
                                <PhoneNumber phoneNumber={buyer.mobileNumber} />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </Col>
                    );
                  })}
            </>
          ) : (
            <Row>
              <Col sm="12" className="add-buyer-button text-right">
                {this.state.userType === message.ACCTOWNER &&
                  this.props.transStatus !== "COMPLETED" && (
                    // localStorage.getItem("isActive") === "true" &&(
                    //   <Button
                    //     variant="transparent"
                    //     className="p-0"
                    //     onClick={() => {
                    //       this.clearForm(false);
                    //       this.buyerInfoModal();
                    //       this.setState({
                    //         isDisabled: true,
                    //         isShowEmailValidation: false
                    //       });
                    //     }}
                    //   >
                    //     <AddCircleOutline className="add" />
                    //   </Button>
                    // )
                    <Button
                      variant="transparent"
                      className="p-0"
                      onClick={() => {
                        this.clearForm(false);
                        this.buyerInfoModal();
                        this.setState({
                          isDisabled: true,
                          isShowEmailValidation: false,
                        });
                      }}
                    >
                      <AddCircleOutline className="add" />
                    </Button>
                  )}
              </Col>
              <Col xs={12}>
                <div className="brokerage-fees mb-3">
                  {this.state.buyers && this.state.buyers.length > 0 && (
                    <div className="brokerage-fees-body">
                      <Table className="add-buyer-table update-render">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>

                            {this.state.buyers.length > 1 &&
                              this.state.userType === message.ACCTOWNER &&
                              this.props.transStatus !== "COMPLETED" && (
                                <th className="buyer-action">Action</th>
                              )}
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.buyers &&
                            this.state.buyers
                              .filter((buyer) => buyer !== null)
                              .map((buyer, ind) => {
                                return (
                                  <tr key={"buyer_" + ind}>
                                    <td className="title">
                                      {" "}
                                      {buyer.firstname + " " + buyer.lastname}
                                    </td>

                                    <td className="value">
                                      <a href={"mailto:" + buyer.email}>
                                        {buyer.email}
                                      </a>
                                    </td>
                                    <td className="value">
                                      <a href={"tele:" + buyer.mobileNumber}>
                                        <PhoneNumber
                                          phoneNumber={buyer.mobileNumber}
                                        />
                                      </a>
                                    </td>

                                    {this.state.buyers.length > 1 &&
                                      this.state.userType ===
                                        message.ACCTOWNER &&
                                      this.props.transStatus !==
                                        "COMPLETED" && (
                                        <td>
                                          <div className="status">
                                            <Button
                                              className="trash-icn"
                                              variant="transparent"
                                              onClick={(e) =>
                                                this.deletePrompt(ind)
                                              }
                                            >
                                              <Delete />
                                            </Button>
                                          </div>
                                        </td>
                                      )}
                                  </tr>
                                );
                              })}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          )}
        </Row>

        <Modal
          show={this.state.buyerInfo}
          onHide={() => this.buyerInfoModal()}
          initialValues={this.state.buyerDataInfo}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med"
        >
          <Formik
            validateOnBlur={true}
            initialValues={this.state.buyerDataInfo}
            enableReinitialize={true}
            validationSchema={
              this.state.isEmailValid || this.state.isDisabled
                ? Yup.object().shape({
                    email: Yup.string()
                      .email(message.ENTER_VALID_EMAIL)
                      .required(message.ENTER_EMAIL),
                  })
                : Yup.object().shape({
                    firstname: Yup.string().required(
                      message.ENTER_CLIENT_FIRST_NAME
                    ),
                    lastname: Yup.string().required(
                      message.ENTER_CLIENT_LAST_NAME
                    ),
                    email: Yup.string()
                      .email(message.ENTER_VALID_EMAIL)
                      .required(message.ENTER_EMAIL)
                      .nullable(),
                    mobileNumber: Yup.string()
                      .nullable()
                      .required(message.ENTER_MOBILE_NUMBER)
                      .test(
                        "mobileNumber",
                        message.ENTER_VALID_MOBILE,
                        (value) => {
                          if ((value || "").length === 10) {
                            return true;
                          }
                          return false;
                        }
                      ),
                  })
            }
            onSubmit={(values) => {
              if (this.state.isEdit) {
                this.updateRecord(values);
              } else {
                this.addRecord(values);
              }
            }}
          >
            {({
              errors,
              values,
              handleBlur,
              setFieldValue,

              touched,

              setFieldError,
            }) => (
              <Form className="form-sm form-admin">
                <Modal.Header closeButton>
                  <Modal.Title id="example-custom-modal-styling-title">
                    Buyer Information
                  </Modal.Title>
                </Modal.Header>

                <Modal.Body className="pb-0">
                  <Row>
                    <Col xs={12} sm={6}>
                      <div className="form-group">
                        <label className="form-label" htmlFor="email">
                          E-mail Address<span className="text-danger">*</span>
                        </label>
                        <Field
                          name="email"
                          type="text"
                          value={values.email}
                          onChange={(e) => {
                            setFieldValue("email", e.target.value);
                            this.checkEmailExist(
                              e.target.value,
                              errors,
                              setFieldError
                            );
                          }}
                          className={
                            "form-control" +
                            (errors.email && touched.email ? " is-invalid" : "")
                          }
                        />

                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {errors.email}
                        </div>
                        {this.state.isShowEmailValidation && (
                          <div
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            Buyer already exist
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col xs={12} sm={6}>
                      <div className="form-group">
                        <label className="form-label" htmlFor="mobileNumber">
                          Mobile Number<span className="text-danger">*</span>
                        </label>

                        {this.state.isEmailValid || this.state.isDisabled ? (
                          <Field
                            name="mobileNumber"
                            type="text"
                            disabled
                            value={formatPhoneNumber(values.mobileNumber)}
                            onChange={(e) => {
                              var mob = e.target.value
                                .toString()
                                .toString()
                                .replace(/-/g, "");
                              setFieldValue("mobileNumber", mob);
                            }}
                            className={
                              "form-control" +
                              (errors.mobileNumber && touched.mobileNumber
                                ? " is-invalid"
                                : "")
                            }
                          />
                        ) : (
                          <InputMask
                            mask="999-999-9999"
                            maskChar=""
                            className={
                              "form-control" +
                              (errors.mobileNumber && touched.mobileNumber
                                ? " is-invalid"
                                : "")
                            }
                            formControlProps={{
                              fullWidth: true,
                            }}
                            value={values.mobileNumber}
                            name="mobileNumber"
                            onChange={(e) => {
                              var mob = e.target.value
                                .toString()
                                .toString()
                                .replace(/-/g, "");
                              setFieldValue("mobileNumber", mob);
                            }}
                            onBlur={handleBlur}
                          >
                            {(inputProps) => <Field {...inputProps} />}
                          </InputMask>
                        )}

                        <ErrorMessage
                          name="mobileNumber"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} sm={6}>
                      <div className="form-group">
                        <label className="form-label" htmlFor="firstname">
                          Buyers First Name
                          <span className="text-danger">*</span>
                        </label>
                        <Field
                          name="firstname"
                          type="text"
                          disabled={
                            this.state.isEmailValid || this.state.isDisabled
                          }
                          value={values.firstname}
                          className={
                            "form-control field_ucfirst" +
                            (errors.firstname && touched.firstname
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="firstname"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col xs={12} sm={6}>
                      <div className="form-group">
                        <label className="form-label" htmlFor="lastname">
                          Buyers Last Name<span className="text-danger">*</span>
                        </label>
                        <Field
                          name="lastname"
                          type="text"
                          disabled={
                            this.state.isEmailValid || this.state.isDisabled
                          }
                          value={values.lastname}
                          className={
                            "form-control field_ucfirst" +
                            (errors.lastname && touched.lastname
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="lastname"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="primary"
                    type="submit"
                    size="sm"
                    className="btn-blue w-140"
                  >
                    Save
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>

        {/* Delete Modal */}
        <Modal
          show={this.state.deletePrompt}
          onHide={() => this.deletePrompt()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}
        >
          <Modal.Body className="pb-0 text-center">
            <HelpOutline />
            <p>Are you sure you want to delete?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => {
                this.deletePrompt();
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.deleteRecord(this.state.deleteIndex);
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profileData: state.reducer.profileData,
  };
};

export default connect(
  mapStateToProps,
  {}
)(Buyers);
